export default __webpack_public_path__ + "static/cap1-43c8f22a290e6db7310a18fb50ca2057.png";